import { Controller } from "stimulus"
import { GoogleConversionTracking } from '../helpers'

export default class extends Controller {
  connect() {
    this.tracker = new GoogleConversionTracking(false, 'AW-814094295/1vF-CMHB0e0YENevmIQD')
    this.tracker.reportConversion()
  }
}